import React from "react";
import clsx from "clsx";

import FormField from "../../Shared/Form/FormField";

const StatusActionModal = ({
  statusActionModal,
  isStatusUpdating,
  onClose,
  onConfirm,
  resigningDate,
  onResigningDateChange,
}) => {
  if (!statusActionModal.isOpen) {
    return null;
  }

  const statusActionTitle =
    statusActionModal.command === "activate" ? "Activate" : "Deactivate";
  const statusActionDescription =
    statusActionModal.command === "activate"
      ? "Are you sure you want to activate?"
      : "Are you sure you want to deactivate?";

  return (
    <div className="user-modal-overlay">
      <div className="user-modal status-action-modal">
        <div className="user-modal-header">
          <h3>
            {statusActionTitle} {statusActionModal.user?.name || "User"}
          </h3>
          <button
            className="close-btn"
            type="button"
            onClick={onClose}
            disabled={isStatusUpdating}
          >
            ×
          </button>
        </div>
        <div className="user-modal-body">
          <p className="status-action-description">{statusActionDescription}</p>
          {statusActionModal.command === "deactivate" && (
            <div className="status-action-date-field">
              <FormField
                id="resigning-date"
                name="resigning_date"
                title="Resigning Date"
                type="date"
                value={resigningDate}
                onChange={(event) => onResigningDateChange(event.target.value)}
                disabled={isStatusUpdating}
              />
            </div>
          )}
        </div>
        <div className="user-modal-footer">
          <button
            className="cancel-btn"
            type="button"
            onClick={onClose}
            disabled={isStatusUpdating}
          >
            Cancel
          </button>
          <button
            className={clsx(
              "submit-btn",
              "status-action-btn",
              statusActionModal.command
            )}
            type="button"
            onClick={onConfirm}
            disabled={isStatusUpdating}
          >
            {isStatusUpdating ? "Please wait..." : statusActionTitle}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusActionModal;
